export const BUREAU_LOGOS: Record<string, string> = {
  equifax: '/logos/equifax.svg',
  experian: '/logos/experian.svg',
  transunion: '/logos/transunion.svg',
};

export const getBureauLogo = (bureau: string): string | undefined =>
  BUREAU_LOGOS[bureau.toLowerCase()];
